app.factory("TimetableService", ["$http",
    function ($http) {
        var TimetableService = {};

        TimetableService.list = function (params) {
            return $http.get("/timetable/list", {
                params: {
                    page: params.page || 1,
                    limit: params.limit || 10,
                    building: params.building,
                    floor: params.floor,
                    room: params.room,
                    seatCountFrom: params.seatCountFrom,
                    seatCountTo: params.seatCountTo,
                    withComputers: params.withComputers,
                    withSmartBoard: params.withSmartBoard
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        TimetableService.subjectList = function (params) {
            return $http.get("/timetable/subject/list", {
                params: {
                    query: params.query,
                    page: params.page || 1,
                    limit: params.limit || 10,
                    lecturer: params.lecturer,
                    subject: params.subject,
                    sessionType: params.sessionType,
                    isDefined: params.isDefined
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        TimetableService.insertGroup = function (params) {
            return $http.post("/timetable/subject/insert", {
                sessions: params.sessions,
                sessionGroup: params.group
            }).then(function (resp) {
                return resp.data;
            })
        };

        TimetableService.fetchRooms = function (params) {
            return $http.get("/timetable/room/list", {
                params: {
                    query: params
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        TimetableService.dashboard = function (params) {
            return $http.get("/timetable/dashboard", {
                params: {
                    dayOfWeek: params.dayOfWeek,
                    startTime: params.startTime
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        TimetableService.addRoom = function (params) {
            return $http.post("/timetable/room/add", {
                name: params.name,
                area: params.area,
                seatCount: params.seatCount,
                floor: params.floor,
                building: params.building,
                withComputers: params.withComputers,
                withSmartBoard: params.withSmartBoard,
                additional: params.additional
            }).then(function (resp) {
                return resp.data;
            });
        };

        TimetableService.editRoom = function (params) {
            return $http.post("/timetable/room/edit", {
                roomId: params.roomId,
                name: params.name,
                area: params.area,
                seatCount: params.seatCount,
                floor: params.floor,
                building: params.building,
                withComputers: params.withComputers,
                withSmartBoard: params.withSmartBoard,
                additional: params.additional
            }).then(function (resp) {
                return resp.data;
            });
        };

        TimetableService.removeRoom = function (params) {
            return $http.post("/timetable/room/remove", {roomId: params.roomId}).then(function (resp) {
                return resp.data;
            });
        };

        TimetableService.check = function (params) {
            return $http.post("/timetable/subject/check", {
                sessionGroup: params.sessionGroup,
                sessions: params.sessions
            }).then(function (resp) {
                return resp.data;
            });
        };

        TimetableService.removeFromTable = function (params) {
            return $http.post("/timetable/subject/remove", {
                sessionGroup: params.sessionGroup
            }).then(function (resp) {
                return resp.data;
            });
        };

        TimetableService.exportList = function () {
            var url = "/timetable/list/export";
            window.open(url)
        };

        return TimetableService;
    }
]);